import Monthly from "./monthly/monthly_export.store";
import Yearly from "./yearly/yearly_export.store";

export default {
  modules: { Monthly, Yearly },
};
